import { SelectHTMLAttributes, forwardRef } from 'react'
import { cn } from '../../utils'
import styles from './Select.module.css'

export interface SelectOption {
  value: string | number
  label: string
  disabled?: boolean
}

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  options?: SelectOption[]
  /** 'sm' = 28px height, 'md' = 32px (default) */
  selectSize?: 'sm' | 'md'
  /** Stretch to fill the available width */
  block?: boolean
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  function Select({ options, selectSize, block, className, children, ...rest }, ref) {
    return (
      <select
        ref={ref}
        className={cn(
          styles.select,
          selectSize === 'sm' && styles.sm,
          block && styles.block,
          className,
        )}
        {...rest}
      >
        {options
          ? options.map(o => (
              <option key={o.value} value={o.value} disabled={o.disabled}>
                {o.label}
              </option>
            ))
          : children}
      </select>
    )
  },
)
